import img_plumber from '../assets/plumber_result.jpg';
import img_roofer from '../assets/roofer_result.jpg';
import img_medspa from '../assets/medspa-owner_result.jpg';
import img_electrician from '../assets/electrician_result.jpg';
import img_hvac from '../assets/hvac-owner_result.jpg';
import img_landscaper from '../assets/landscaper_result.jpg';
import img_painter from '../assets/painter_result.jpg';
import img_pest_control from '../assets/pert-control_result.jpg';
import img_auto_mechanic from '../assets/auto-repair_result.jpg';
import img_locksmith from '../assets/locksmith_result.jpg';

const PersonaImages = {
	'Plumber': img_plumber,
	'Roofer': img_roofer,
	'Med Spa Owner': img_medspa,
	'Electrician': img_electrician,
	'HVAC Technician': img_hvac,
	'Landscaper': img_landscaper,
	'Painter': img_painter,
	'Pest Control Operator': img_pest_control,
	'Auto Mechanic': img_auto_mechanic,
	'Locksmith': img_locksmith,
};

export default PersonaImages;
